import AccessibeTrigger from './AccessibeTrigger';

export default AccessibeTrigger;
